export default "<div class=\"exutoire\">\n  {{ExutoireInComponent}}\n</div>\n\n";